export function DoOptimizePages(wsMgr) {
  var dMgr = wsMgr.GetDocMgr();
  var docPrefs = dMgr.GetDocPrefs();
  var pageOpt = docPrefs.GetPageOpt(true);

  var aspectRatio = pageOpt.GetAspectRatio();
  var allowSort = pageOpt.GetAllowSort();
  var treeSingles = pageOpt.GetTreeSingles();
  var branchPref = pageOpt.GetBranchPref();

  wsMgr.DoOptimizePage(aspectRatio, allowSort, treeSingles, branchPref, "", true, false, false);
}
